import createIcon from '../../createIcon';

/**
 * @component @name Sip
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcuNSAxMC41SDE1LjVWMTEuNUgxNy41VjEwLjVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMjAgNEg0QzIuOSA0IDIgNC45IDIgNlYxOEMyIDE5LjEgMi45IDIwIDQgMjBIMjBDMjEuMSAyMCAyMiAxOS4xIDIyIDE4VjZDMjIgNC45IDIxLjEgNCAyMCA0Wk0xMCAxMC41SDYuNVYxMS4yNUg5QzkuNTUgMTEuMjUgMTAgMTEuNyAxMCAxMi4yNVYxNEMxMCAxNC41NSA5LjU1IDE1IDkgMTVINVYxMy41SDguNVYxMi43NUg2QzUuNDUgMTIuNzUgNSAxMi4zIDUgMTEuNzVWMTBDNSA5LjQ1IDUuNDUgOSA2IDlIMTBWMTAuNVpNMTMgMTVIMTFWOUgxM1YxNVpNMTkgMTJDMTkgMTIuNTUgMTguNTUgMTMgMTggMTNIMTUuNVYxNUgxNFY5SDE4QzE4LjU1IDkgMTkgOS40NSAxOSAxMFYxMloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Sip = createIcon('Sip', [
  ['path', { d: 'M17.5 10.5H15.5V11.5H17.5V10.5Z', key: 'l2j6f' }],
  [
    'path',
    {
      d: 'M20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM10 10.5H6.5V11.25H9C9.55 11.25 10 11.7 10 12.25V14C10 14.55 9.55 15 9 15H5V13.5H8.5V12.75H6C5.45 12.75 5 12.3 5 11.75V10C5 9.45 5.45 9 6 9H10V10.5ZM13 15H11V9H13V15ZM19 12C19 12.55 18.55 13 18 13H15.5V15H14V9H18C18.55 9 19 9.45 19 10V12Z',
      key: '1w1p1u',
    },
  ],
]);

export default Sip;
